import React from 'react';
import { withReferer } from 'plugins/contextual-back';
import { columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { renderCaseCustomer } from './common';

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 8)}
      label="Nom du chantier"
    />,
    <Column
      key="creationDate"
      dataKey="creationDate"
      width={columnWidth(width, 8)}
      label="Date de création"
    />,
  ];
}

function render(url, from) {
  const caseUrl = id => withReferer(`/pco-manager/aast/cases/${id}`, from);

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderList(rowClickedUrl, loadNextUrl, renderColumns);
}

export default function list(ctx) {
  render(
    '/pco-manager/aast/cases-ongoing.json',
    '/pco-manager/aast/cases-ongoing'
  );
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases/list-ongoing.js